import React, { useState } from "react";
import { Button, Upload } from "antd";
import { UploadOutlined, FileOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { startEnviarDocumentoEdega } from "../../../../context/actions/detalleActions";

export const Edega = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { asistencia } = useSelector((state) => state.detalleReducer);
  const edegaUrl = asistencia?.edega?.url;

  const handleClick = async () => {
    if (!file) return;

    setLoading(true);
    const ok = await dispatch(startEnviarDocumentoEdega(file.name, file));

    if (ok) {
      setFile(null);
    }

    setLoading(false);
  };

  const handleOpenDocument = () => {
    if (edegaUrl) {
      window.open(edegaUrl, "_blank");
    }
  };

  const props = {
    beforeUpload: (selectedFile) => {
      setFile(selectedFile);
      return false;
    },
    maxCount: 1,
    showUploadList: {
      showRemoveIcon: false,
    },
  };

  if (edegaUrl) {
    return (
      <div style={{ maxWidth: 600 }}>
        <Button
          type="link"
          icon={<FileOutlined />}
          onClick={handleOpenDocument}
          style={{ fontSize: 16, padding: 0, marginLeft: 18 }}
        >
          Ver documento Edega
        </Button>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 600 }}>
      <Upload {...props}>
        <Button icon={<UploadOutlined />} disabled={loading}>
          Seleccione archivo
        </Button>
      </Upload>

      <div style={{ marginTop: 10 }}>
        <Button
          type="primary"
          disabled={!file}
          loading={loading}
          onClick={handleClick}
        >
          Enviar
        </Button>
      </div>
    </div>
  );
};
